import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { CapNavigationItem } from '../../shared/components/bottom-sheet/bottom-sheet.component';
import { AuthComponent } from '../../features/auth/pages/auth.component';
import {
  HeaderV2Component,
  NavigationButton,
} from '../../shared/components/header-v2/header-v2.component';
import { AiAssistantV2Component } from '../../shared/components/ai-assistant-v2/ai-assistant-v2.component';
import { BottomSheetComponent } from '../../shared/components/bottom-sheet/bottom-sheet.component';

const DEFAULT_NAV_BUTTONS: ReadonlyArray<NavigationButton> = [
  {
    icon: '/public/svgs/hat-w.svg',
    alt: 'app.components.headerV2.courses',
    route: 'courses',
  },
];

const DEFAULT_CAP_NAV_ITEMS: ReadonlyArray<CapNavigationItem> = [
  {
    label: 'app.components.bottomSheet.studies',
    route: ['/courses', 'my-studies'],
    ariaLabel: 'app.components.bottomSheet.studies',
  },
  {
    label: 'app.components.bottomSheet.courses',
    route: ['/courses', 'my-courses'],
    ariaLabel: 'app.components.bottomSheet.courses',
  },
];
@Component({
  selector: 'app-school',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    AuthComponent,
    HeaderV2Component,
    AiAssistantV2Component,
    BottomSheetComponent,
  ],
  templateUrl: './school-layout.component.html',
  styleUrl: './school-layout.component.scss',
})
export class SchoolLayoutComponent {
  private router = inject(Router);
  public isAuthRoute = signal(false);

  // AI assistant parallax progress (0 at bottom/peek, 1 at fully open)
  public progress = signal(1);
  public capNavItems = signal<CapNavigationItem[]>([]);

  public navigationButtons =
    signal<ReadonlyArray<NavigationButton>>(DEFAULT_NAV_BUTTONS);

  // Assistant transform now handled inside the assistant component via sheetProgress

  onSheetProgress(value: number): void {
    // 0 at bottom (peek), 1 at fully open
    this.progress.set(value);
  }

  constructor() {
    this.checkRoute();
    // No bottom sheet logic here anymore
  }

  private checkRoute() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(() => {
      this.isAuthRoute.set(this.router.url.includes('/auth'));
      // Configure cap navigation per parent route
      if (this.router.url.startsWith('/courses')) {
        this.capNavItems.set([...DEFAULT_CAP_NAV_ITEMS]);
      } else {
        this.capNavItems.set([]);
      }
    });
  }
}
